import { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { TV_LOCALE } from '../locales/languages';
import { t } from '../utils/translations';

export default function TradingViewTicker() {
  const container = useRef(null);
  const { language } = useLanguage();

  useEffect(() => {
    const el = container.current;
    if (!el) return;

    while (el.firstChild) el.removeChild(el.firstChild);

    const widget = document.createElement('div');
    widget.className = 'tradingview-widget-container__widget';
    el.appendChild(widget);

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.type = 'text/javascript';
    script.async = true;
    script.textContent = JSON.stringify({
      symbols: [
        { proName: 'FOREXCOM:SPXUSD', title: 'S&P 500' },
        { proName: 'FOREXCOM:NSXUSD', title: 'NASDAQ' },
        { proName: 'FOREXCOM:DJI', title: 'Dow Jones' },
        { description: t('charts.gold', language), proName: 'OANDA:XAUUSD' },
        { description: 'Silver', proName: 'OANDA:XAGUSD' },
        { description: 'Oil WTI', proName: 'TVC:USOIL' },
        { description: 'Bitcoin', proName: 'BINANCE:BTCUSDT' },
        { description: 'Ethereum', proName: 'BINANCE:ETHUSDT' },
        { description: 'EUR/USD', proName: 'FX:EURUSD' },
        { description: 'USD/JPY', proName: 'FX:USDJPY' },
        { description: 'VIX', proName: 'CBOE:VIX' },
      ],
      showSymbolLogo: true,
      isTransparent: true,
      displayMode: 'adaptive',
      colorTheme: 'dark',
      locale: TV_LOCALE[language] || 'en',
    });

    try {
      el.appendChild(script);
    } catch (error) {
      console.error('Error loading TradingView widget:', error);
    }

    return () => {
      try {
        while (el.firstChild) el.removeChild(el.firstChild);
      } catch (_) {
        /* ignore */
      }
    };
  }, [language]);

  return (
    <div style={{
      width: '100%',
      background: 'rgba(0,0,0,0.3)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(0,255,200,0.1)',
      borderBottom: '1px solid rgba(0,255,200,0.1)',
      padding: '0',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #00ffc8, transparent)',
        opacity: 0.3,
      }} />

      <div className="tradingview-widget-container" ref={container} style={{
        height: '46px',
        filter: 'brightness(1.1)',
      }} />

      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #00ffc8, transparent)',
        opacity: 0.3,
      }} />
    </div>
  );
}
